// App.js
import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Details />
      {/* <OurStory /> */}
      <EventDetails />
      <CountdownTimer />
      <RSVP />
      {/* <PhotoGallery /> */}
      <Footer />
    </div>
  );
}

// Navigation Component
function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-content">
        <h1 className="nav-title">Anfal & Sameena</h1>
        <button
          className={`nav-toggle ${menuOpen ? 'open' : ''}`}
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <a href="#timer" onClick={closeMenu}>Countdown</a>
          <a href="#story" onClick={closeMenu}>Invitation</a>
          <a href="#details" onClick={closeMenu}>Details</a>
          {/* <a href="#gallery" onClick={closeMenu}>Gallery</a> */}
        </div>
      </div>
    </nav>
  );
}

// Hero Component
function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h2 className="hero-subtitle">We're Getting Married</h2>
          <h1 className="hero-title">
            Anfal
            <span className="heart" style={{ fontSize: '0.6em' }}>with</span>
            Sameena
          </h1>
          <p className="hero-date">January 18, 2026 (1447 Rajab 29)</p>
          <div className="hero-scroll">
            {/* <span>Scroll for Love Story</span> */}
            <div className="scroll-arrow">↓</div>
          </div>
        </div>
      </div>
      <div className="floating-hearts">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="floating-heart"></div>
        ))}
      </div>
    </section>
  );
}

// Countdown Timer Component
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const weddingDate = new Date('January 18, 2026 11:30:00').getTime();
    const now = new Date().getTime();
    const difference = weddingDate - now;

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000)
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="timer" className="countdown-section">
      <div className="countdown-container">
        <h2 className="section-title">Counting the Moments</h2>
        <div className="countdown-timer">
          <div className="time-unit">
            <div className="time-value">{timeLeft.days}</div>
            <div className="time-label">Days</div>
          </div>
          <div className="time-separator">:</div>
          <div className="time-unit">
            <div className="time-value">{timeLeft.hours.toString().padStart(2, '0')}</div>
            <div className="time-label">Hours</div>
          </div>
          <div className="time-separator">:</div>
          <div className="time-unit">
            <div className="time-value">{timeLeft.minutes.toString().padStart(2, '0')}</div>
            <div className="time-label">Minutes</div>
          </div>
          <div className="time-separator">:</div>
          <div className="time-unit">
            <div className="time-value">{timeLeft.seconds.toString().padStart(2, '0')}</div>
            <div className="time-label">Seconds</div>
          </div>
        </div>
        {/* <div className="timer-message">
          Until we say "I Do" in the presence of our loved ones
        </div> */}
        <div className="timer-flower-decoration">
          <div className="flower-left">❀</div>
          <div className="flower-right">❀</div>
        </div>
      </div>
    </section>
  );
}



function Details() {
  const [showNamesTab, setShowNamesTab] = useState(false);

  const happinessNames = [
    "Ashitha",
    "Amitha",
    "Hamdan",
    "Fathima Sahadi",
    "Amina",
    "Fahmitha",
    "Amna",
    "Mihila",
    "Yaseen",
    "Naseeb",
    "Ayzal",
    "Aydhin",
    "Ayzin",
    "Irfan",
    "Rifai",
    "Iqbal",
  ];

  return (
    <section id="story" className="story-section">
      <h2 className="section-title">Wedding Invitation</h2>
      <div className="story-tabs">
        <button className={`story-tab ${!showNamesTab ? "active" : ""}`} onClick={() => setShowNamesTab(false)}>
          Invitation
        </button>
        {showNamesTab && (
          <button className="story-tab active" style={{ pointerEvents: "none" }}>
            Wellwishers
          </button>
        )}
      </div>
      <div
        className="story-content"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          padding: "1rem",
          boxSizing: "border-box",
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto"
        }}
      >
        {!showNamesTab ? (
          <>
            <div style={{ marginBottom: 0 }}>
              <h3
                style={{
                  fontSize: "2em",
                  '@media (max-width: 600px)': { fontSize: "2.2em" }
                }}
                className="story-person-name"
              >
                Anfal Hassan
              </h3>
              <p style={{ wordBreak: "break-word", fontSize: "1em"}}>
                <strong>S/o Mr. Hassan P P &amp; Mrs. Ramla KN</strong>
                <br />
                Pirambyllikudy House, Chelakkulam, Perumbavoor
                <br />
                <span style={{ fontSize: "0.9em" }}>
                  (Grandson of Late Athan Pareeth &amp; Kunjipathumma, Pirambyllikudy
                  <br />
                  | K.A Neena &amp; Aisha, Kattukudy)
                </span>
              </p>
            </div>
            <div style={{ marginBottom: 0 }}>
              <h3 style={{ fontSize: "2em" }}>Sameena Abdul Khader</h3>
              <p style={{ wordBreak: "break-word", fontSize: "1em" }}>
                <span style={{ fontSize: "1em" }}>
                  <strong>D/o Mr. Abdul Khader &amp; Mrs. Safiya</strong>
                  <br />
                  Chelamalayil House, Pezhakkappilly, Muvattupuzha
                </span>
              </p>
            </div>
            <div style={{ marginBottom: 0 }}>
              <p style={{ wordBreak: "break-word", fontSize: "1em" }}>
                <strong>Date : </strong> Sunday 18th January 2026 <br/>
                (1447 Rajab 29)
                <br />
                <br />
                <strong>Nikkah : </strong>Central Jummah Masjid, Pezhakkappilly, Muvattupuzha at 11:30AM
                <br />
                <br />
                <strong>Lunch : </strong> Kavitha Convention Centre, Thrikkalathoor, Muvattupuzha
                <br />
                <br />
                <strong>Reception : </strong> MJM Hall, Vengola, Perumbavoor at 6:00 PM Onwards
              </p>
            </div>
            <div>
              <p style={{ wordBreak: "break-word", fontSize: "1em" }}>
                <strong>Sharing the Happiness : </strong> Ameer Hassan, Fathima Swaliha, Safna C A
              </p>
              <button
                style={{
                  marginTop: "0.7rem",
                  padding: "0.4em 1.3em",
                  fontSize: "1em",
                  border: "none",
                  background: "#800020",
                  color: "#fff",
                  borderRadius: "20px",
                  cursor: "pointer",
                  boxShadow: "0 2px 6px 0 rgba(127,93,244,0.10)"
                }}
                onClick={() => setShowNamesTab(true)}
              >
                View More
              </button>
            </div>
            <style>
              {`
                @media (max-width: 600px) {
                  .story-content {
                    padding: 0.5rem !important;
                    max-width: 100vw !important;
                  }
                  .story-content h3 {
                    font-size: 1.1em !important;
                  }
                  .story-content p {
                    font-size: 0.98em !important;
                  }
                }
              `}
            </style>
          </>
        ) : (
          <div>
            <h3 style={{ fontSize: "1.4em", marginBottom: "1em" }}>Well-wishers & Family</h3>
            <ul 
              style={{ 
                paddingLeft: 0, 
                listStyle: "none", 
                marginBottom: "1.5em", 
                display: "flex",
                flexWrap: "wrap",
                gap: "0.6em"
              }}>
              {happinessNames.map((name, i) => (
                <li
                  key={name + i}
                  style={{
                    padding: "0.45em 1.1em",
                    margin: 0,
                    background: `linear-gradient(90deg, #ece7fc 0%, #f6f2ff 100%)`,
                    borderRadius: "20px",
                    fontSize: "1.05em",
                    fontWeight: "600",
                    boxShadow: "0 2px 8px 0 rgba(127,93,244,0.10)",
                    color: "#6d3690",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e3d8fe",
                    letterSpacing: "0.02em"
                  }}
                >
                  <span style={{
                    fontSize: "1.15em",
                    marginRight: "0.6em"
                  }}>💖</span> {name}
                </li>
              ))}
            </ul>
            <button
              style={{
                padding: "0.4em 1.3em",
                fontSize: "1em",
                border: "none",
                background: "#7f5df4",
                color: "#fff",
                borderRadius: "20px",
                cursor: "pointer",
                boxShadow: "0 2px 6px 0 rgba(127,93,244,0.10)"
              }}
              onClick={() => setShowNamesTab(false)}
            >
              Back to Invitation
            </button>
          </div>
        )}
      </div>
      <div className="story-illustration">
        <div className="heart-line"></div>
        <div className="heart-connector"></div>
      </div>
    </section>
  );
}

// // Our Story Component
// function OurStory() {
//   const [activeTab, setActiveTab] = useState('how');

//   const stories = {
//     how: {
//       title: "How We Met",
//       content: "Our story began unexpectedly, when two souls connected through fate. It was a moment where time stood still, and we knew something special had just begun."
//     },
//     proposal: {
//       title: "The Proposal",
//       content: "Under a canopy of stars, with love as our witness, Anfal asked Sameena to be his forever. The yes came with tears of joy and a promise of forever."
//     },
//     journey: {
//       title: "Our Journey",
//       content: "Every moment has been a step closer to this day. Through laughter, understanding, and endless support, our bond grew stronger each day."
//     }
//   };

//   return (
//     <section id="story" className="story-section">
//       <h2 className="section-title">Our Love Story</h2>
//       <div className="story-tabs">
//         {Object.entries(stories).map(([key, story]) => (
//           <button
//             key={key}
//             className={`story-tab ${activeTab === key ? 'active' : ''}`}
//             onClick={() => setActiveTab(key)}
//           >
//             {story.title}
//           </button>
//         ))}
//       </div>
//       <div className="story-content">
//         <h3>{stories[activeTab].title}</h3>
//         <p>{stories[activeTab].content}</p>
//       </div>
//       <div className="story-illustration">
//         <div className="heart-line"></div>
//         <div className="heart-connector"></div>
//       </div>
//     </section>
//   );
// }

// Event Details Component
function EventDetails() {
  return (
    <section id="details" className="details-section">
      <div className="details-container">
        <div className="detail-card">
          <div className="detail-icon">🕌</div>
          <h3>Nikkah Ceremony</h3>
          <p>11:30 AM</p>
          <p>Central Jummah Masjid, Pezhakkappilly</p>
          <p>Lunch : Kavitha Convention Centre</p>
           <p>Thrikkalathoor, Muvattupuzha</p>
          <a 
            href="https://maps.app.goo.gl/Dn8Bz6nCAUt5N8SY8"
            target="_blank" 
            rel="noopener noreferrer"
            className="location-link"
          >
            View on Google Maps →
          </a>
        </div>
        <div className="detail-card">
          <div className="detail-icon">🎉</div>
          <h3>Reception</h3>
          <p>6:00 PM Onwards</p>
          <p>MJM Hall</p>
          <p>Vengola, Perumbavoor</p>
          <a 
            href="https://maps.app.goo.gl/yRGRo75YbUs6LSgx6?g_st=ipc" 
            target="_blank" 
            rel="noopener noreferrer"
            className="location-link"
          >
            View on Google Maps →
          </a>
        </div>
      </div>
      
    </section>
  );
}

// RSVP Component
function RSVP() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    guests: '1',
    attending: 'yes'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your response! We look forward to celebrating with you.');
    setFormData({ name: '', email: '', guests: '1', attending: 'yes' });
  };

  // return (
    // <section id="rsvp" className="rsvp-section">
    //   <div className="rsvp-container">
    //     <h2 className="section-title">RSVP</h2>
    //     <p className="rsvp-subtitle">Please respond by December 31, 2025</p>
        
    //     <form className="rsvp-form" onSubmit={handleSubmit}>
    //       <div className="form-group">
    //         <input
    //           type="text"
    //           placeholder="Your Name"
    //           value={formData.name}
    //           onChange={(e) => setFormData({...formData, name: e.target.value})}
    //           required
    //         />
    //       </div>
          
    //       <div className="form-group">
    //         <input
    //           type="email"
    //           placeholder="Email Address"
    //           value={formData.email}
    //           onChange={(e) => setFormData({...formData, email: e.target.value})}
    //           required
    //         />
    //       </div>
          
    //       <div className="form-row">
    //         <div className="form-group">
    //           <label>Number of Guests</label>
    //           <select
    //             value={formData.guests}
    //             onChange={(e) => setFormData({...formData, guests: e.target.value})}
    //           >
    //             {[1,2,3,4,5].map(num => (
    //               <option key={num} value={num}>{num}</option>
    //             ))}
    //           </select>
    //         </div>
            
    //         <div className="form-group">
    //           <label>Will you attend?</label>
    //           <div className="attending-options">
    //             <label>
    //               <input
    //                 type="radio"
    //                 value="yes"
    //                 checked={formData.attending === 'yes'}
    //                 onChange={(e) => setFormData({...formData, attending: e.target.value})}
    //               />
    //               <span>Joyfully Accept</span>
    //             </label>
    //             <label>
    //               <input
    //                 type="radio"
    //                 value="no"
    //                 checked={formData.attending === 'no'}
    //                 onChange={(e) => setFormData({...formData, attending: e.target.value})}
    //               />
    //               <span>Regretfully Decline</span>
    //             </label>
    //           </div>
    //         </div>
    //       </div>
          
    //       <button type="submit" className="submit-btn">
    //         Send Response
    //       </button>
    //     </form>
    //   </div>
    // </section>
  // );
}

// Photo Gallery Component
// function PhotoGallery() {
//   const [selectedImage, setSelectedImage] = useState(null);

//   const photos = [
//     { id: 1, emoji: "📸", caption: "First Date" },
//     { id: 2, emoji: "🌅", caption: "Sunset Moments" },
//     { id: 4, emoji: "🎄", caption: "Festive Celebrations" },
//     { id: 5, emoji: "🌊", caption: "Beach Memories" },
//     { id: 6, emoji: "✨", caption: "Special Moments" }
//   ];

//   return (
//     <section id="gallery" className="gallery-section">
//       <h2 className="section-title">Our Moments</h2>
//       <div className="gallery-grid">
//         {photos.map(photo => (
//           <div 
//             key={photo.id} 
//             className="photo-card"
//             onClick={() => setSelectedImage(photo)}
//           >
//             <div className="photo-emoji">{photo.emoji}</div>
//             <p className="photo-caption">{photo.caption}</p>
//           </div>
//         ))}
//       </div>
      
//       {selectedImage && (
//         <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
//           <div className="modal-content">
//             <div className="modal-emoji">{selectedImage.emoji}</div>
//             <h3>{selectedImage.caption}</h3>
//             <button className="close-modal" onClick={() => setSelectedImage(null)}>
//               ×
//             </button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// Footer Component
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <h3 className="footer-title" style={{ fontSize: "2em" }}>Anfal &amp; Sameena</h3>
        <p className="footer-date">January 18, 2026</p>
        <p className="footer-location">Kochi, Kerala • India</p>   */}
        
        <div className="footer-notes">
          <p>"Love is not about how many days, months, or years you have been together.<br/> 
          Love is about how much you love each other every single day."</p>
        </div>
        
        <div className="footer-contact">
          <p>For any queries, contact us at: <br/> 
          <a href="mailto:anfal.sameena.wedding@gmail.com">anfal.sameena.wedding@gmail.com</a></p>
        </div>
        
        <div className="footer-final">
          <p>With Love and Gratitude<br/>Anfal & Sameena</p>
        </div>
        
        <div className="footer-developer">
          <p>Crafted with Innovation and Powered by <a href="#" target="_blank" rel="noopener noreferrer">TechAppie Inc</a></p>
        </div>
      </div>
    </footer>
  );
}

export default App;